import type { ResolutionEvent } from "../../domain/types/index.js";

export type PlaybackStep = {
  index: number;
  /** null は自動進行しない（gameover で「結果を見る」を待つ）。 */
  holdMs: number | null;
};

const HOLD_MS: Record<ResolutionEvent["kind"], number | null> = {
  progress: 900,
  heal: 900,
  load: 2800,
  deadline: 900,
  overdue: 1600,
  discard: 1500,
  success: 3600,
  failure: 3600,
  gameover: null,
};

export function holdMsFor(event: ResolutionEvent): number | null {
  return HOLD_MS[event.kind];
}

export function buildPlaybackTimeline(events: readonly ResolutionEvent[]): PlaybackStep[] {
  return events.map((event, index) => ({ index, holdMs: holdMsFor(event) }));
}
